<template>
	<form
		:class="['input-sigarus', { 'align-right': type.includes('number') }, { editing }, {readonly}]"
		v-click-outside="cancel"
		@submit.prevent="save"
		@keydown.enter.stop.prevent="save"
		@keydown.esc.capture="cancel"
		@input="error = false"
		@keydown.shift.tab.exact="back"
		@keydown.tab.exact="next"
		v-loading="loading"
	>

		<el-popover
			v-if="mode === 'inline'"
			v-model="showTooltip"
			placement="top"
			title=""
			trigger="manual"
		>

			<el-alert v-if="error" type="error" effect="dark" :closable="false">{{ error.message }}</el-alert>

			<div
				ref="a"
				class="holder"
				slot="reference"
				@click="ondblclick"
			>

				<div
					v-show="!editing && !hideInput"
					class="label"
				>
					<div v-if="value == ''" class="placeholder truncate">
						{{ placeholder }}
					</div>
					<div v-else class="truncate">
						{{ render(value) }}
					</div>

				</div>

				<div :class="[{ editing }]">

					<component
						v-show="editing"
						ref="input"
						class="input-sigarus-component"
						:is="`l-${mainType}`"
						:key="`l-${mainType}`"
						size="small"
						v-model="model"
						v-bind.sync="{...$attrs, ...$props}"
						@input="onInput"
						@save="save"
					/>

					<div v-show="editing" class="buttons buttons-editing">
						<!--<el-button
							title="Cancelar"
							size="small"
							circle
							type="danger"
							@click.stop.prevent="cancel"
							icon="el-icon-close"
						></el-button>-->
					</div>

					<div v-if="extraType && !readonly" class="buttons">

						<el-button
							v-if="['id'].includes(extraType)"
							title="Seleccionar"
							size="small"
							@click.stop.prevent="$emit('go', input)"
						><fa icon="link"/></el-button>

						<el-button
							v-if="['id', 'go'].includes(extraType)"
							title="Ver"
							size="small"
							@click.stop.prevent="$emit('id', input)"
						><fa icon="edit"/></el-button>

					</div>

				</div>

			</div>

		</el-popover>

		<div class="popover" v-else>

			<el-popover
				v-model="showTooltip"
				placement="top"
				title="Editar"
				trigger="manual"
			>

				<div class="holder">

					<el-alert
						v-if="error"
						type="error"
						effect="dark"
						:closable="false"
						style="margin-bottom: 10px;"
					>{{ error.message }}</el-alert>

					<div>
						
						<component
							ref="input"
							class="input-sigarus-component"
							:is="`l-${mainType}`"
							:key="`l-${mainType}`"
							size="small"
							v-model="model"
							v-bind.sync="{...$attrs, ...$props}"
							@input="onInput"
							@save="save"
						/>

						<div v-show="editing" class="buttons buttons-editing">
							<!--<el-button
								title="Cancelar"
								size="small"
								circle
								type="danger"
								@click.stop.prevent="cancel"
								icon="el-icon-close"
							></el-button>-->
						</div>

						<div v-if="extraType && !readonly" class="buttons">

							<el-button
								v-if="['id'].includes(extraType)"
								title="Seleccionar"
								size="small"
								@click.stop.prevent="$emit('go', input)"
							><fa icon="link"/></el-button>

							<el-button
								v-if="['id', 'go'].includes(extraType)"
								title="Ver"
								size="small"
								@click.stop.prevent="$emit('id', input)"
							><fa icon="edit"/></el-button>

						</div>

					</div>

				</div>

				<div
					v-show="!hideInput"
					ref="a"
					slot="reference"
					class="label"
					@click="ondblclick"
				>

					{{ render(value) }}

				</div>

			</el-popover>

		</div>

	</form>
</template>

<script>
	import axios from 'axios'
	import _ from 'lodash'
	import inputConfig from './utils/inputConfig'

	export default {
		name: 'InputSigarus',
		components: inputConfig,
		props: {
			identificador: {
				type: String
			},
			entidad: {
				type: String
			},
			input: {
				type: Object
			},
			value: {
				default: ''
			},
			type: {
				type: String,
				default: 'text'
			},
			saveUrl: {
				type: String,
				default: ''
			},
			mode: {
				type: String,
				default: 'inline'
			},
			siblings: {
				type: Array,
				default: () => []
			},
			readonly: {
				type: Boolean,
				default: false
			},
			placeholder: {
				type: String,
				default: ''
			}
		},
		data () {
			return {
				callHook: (h, val) => val,
				render: val => val,
				error: null,
				editing: false,
				model: '',
				hideInput: false,
				loading: false,

				modelfilter: ''
			}
		},
		watch: {
			value() {
				this.model = _.cloneDeep(this.value)
			}
		},
		computed: {

			showTooltip: {
				get () {

					if (this.mode === 'inline') return !!this.error

					return this.editing

				},
				set () {}
			},

			extraType () {

				const types = this.type.split(':')

				if (types.length < 2) return false

				return types[1]

			},

			mainType () { return this.type.split(':')[0] }

		},
		mounted () {
			
			this.model = _.cloneDeep(this.value)

			if (this.$refs.input && this.$refs.input.$_callHook) this.callHook = this.$refs.input.$_callHook

			if (this.$refs.input && this.$refs.input.$render) this.render = this.$refs.input.$render

			if (this.$refs.input && this.$refs.input.overrideData) Object.assign(this.$data, this.$refs.input.overrideData())
		},
		methods: {

			async save () {

				try {

					let val = this.model
					console.log('save: ',val)

					val = await this.callHook('beforeSave', val)

					if (this.saveUrl !== '') {

						if (this.saveUrl === 'forzar error') throw {
							message: 'Algo sa rompido',
							type: 'Error'
						}

						if (this.saveUrl === 'forzar bien') {
							
							console.log('chachi')

						} else {
							
							this.loading = true
							let resp = await axios.post(this.saveUrl, {
								id: this.identificador,
								entidad: this.entidad,
								field: this.input.key,
								newvalue: `${this.modelfilter}${val}`,
								format: this.input.format
							})
							this.loading = false
							
							if (resp && typeof resp.data !== "object") {

								throw {
									message: 'Ha ocurrido un error al guardar',
									type: 'Error'
								}

							} else if (resp.data.mensajes) {

								this.$emit('saved', resp.data)

							}
							
						}

					}

					val = await this.callHook('afterSave', val)

					this.$emit('input', val)

					this.model = val

					this.stopEditing()

				}
				catch (err) {

					this.error = err

					if (this.$refs.input.focus) this.$refs.input.focus()

					this.loading = false

				}

			},

			async cancel () {
				
				try {

					let val = this.value

					val = await this.callHook('beforeCancel', val)

					val = await this.callHook('afterCancel', val)

					this.model = val

					this.stopEditing()

				}
				catch (err) {

					this.error = err

					if (this.$refs.input.focus) this.$refs.input.focus()

				}

			},

			async onInput (val) {

				try {

					this.error = false

					val = await this.callHook('input', val)

					this.model = val

					if(this.saveUrl == '') {
						this.$emit('input', val)
					}

				} catch(err) {
					
					this.error = err
					console.log(this.error)

					if (this.$refs.input.focus) this.$refs.input.focus()

				}

			},

			async ondblclick () {

				if(this.readonly) return

				let val = this.model

				val = await this.callHook('startEditing', val)

				this.model = val

				this.editing = true

				setTimeout(() => {

					if (this.$refs.input.focus) this.$refs.input.focus()
					if (this.$refs.input.select) this.$refs.input.select()

				}, 100)

			},

			async stopEditing () {

				let val = this.model

				val = await this.callHook('endEditing', val)

				this.model = val

				this.editing = false

				this.error = false

				//setTimeout(() => this.$refs.a.focus(), 200)

			},

			async next (e) {

				if (this.siblings.length === 0) return

				let index = this.siblings.indexOf(this) + 1

				if (index > this.siblings.length - 1) index = 0
				
				// Comprobar si el valor a cambiado
				//console.log('model: ',this.model)
				//console.log('value: ',this.value)
				
				if(this.model != this.value) {
					
					await this.save()
					if(this.error) return

				} else {
					this.stopEditing()
				}
				

				this.siblings[index].ondblclick()

			},

			async back (e) {

				if (this.siblings.length === 0) return

				let index = this.siblings.indexOf(this) - 1

				if (index < 0) index = this.siblings.length - 1

				if(this.model != this.value) {

					await this.save()
					if(this.error) return

				} else {
					this.stopEditing()
				}

				this.siblings[index].ondblclick()

			}

		}
	}
</script>

<style lang="scss">
.input-llod {
	form {
		&.align-right {
			.label, input {
				text-align: right!important;
			}
		}
		&.readonly {
			.label {
				border: 0px;
			}
		}
	}

	.el-popover:focus {
		border: 1px solid #DCDFE6;
		border-radius: 5px;
		outline: 0;
	}

	.label {
		height: 32px;
		line-height: 32px;
		padding: 0 15px;
		border: 1px solid transparent;
		box-sizing: border-box;

    	border-radius: 0px;
		background-color: white;

		&:focus {
			//border: 1px solid #DCDFE6;
			//border-radius: 5px;
			outline: 0;
		}

		&.align-right {
			text-align: right;
		}
		.truncate {
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}

	.holder {
		display: flex;

		&>div:first-child {
			flex-grow: 1;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			font-size: 0.8rem;
		}

		&>div:last-child {
			display: flex;
			align-items: center;

			&.editing {
				flex-grow: 1;
				&.filter {
					flex-flow: column;
				}
			}

			&>.input-sigarus-component {
				flex-grow: 1;
			}

			&>.buttons {
				flex-shrink: 0;
				margin-left: 1px;

				&>* {
					margin-left: 1px !important;
				}

				&.buttons-editing {
					position: absolute;
    				right: -41px;
					z-index: 9;
				}
			}
		}
	}
}
</style>
